import Box from '@mui/material/Box'
import { observer } from 'mobx-react-lite'
import ProgressDotsStore, { ProgressDotsStoreProvider, useProgressDotsStore } from './ProgressDotsStore'
import useStore from 'reusable/mobx-store-utils'
import { themeConfig } from '@gap/shared/theme'

interface ProgressDotsProps {
   totalSteps: number
   index: number
}

export default observer(function ProgressDots(props: ProgressDotsProps) {
   const progressDotsStore = useStore(sp => new ProgressDotsStore(sp), {
      totalSteps: props.totalSteps,
      index: props.index
   })

   return <ProgressDotsStoreProvider store={progressDotsStore}>
      <Box sx={{
         height: 60,
         display: 'flex',
         flexDirection: 'row',
         alignItems: 'center',
         justifyContent: 'center',
         gap: 1,
         px: 3
      }}>
         <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            {progressDotsStore.totalSteps.map((_, index) => <ProgressDot index={index} key={index} />)}
         </Box>
      </Box>
   </ProgressDotsStoreProvider>
})

const ProgressDot = observer(function ProgressDot(props: { index: number }) {
   const progressDotsStore = useProgressDotsStore()
   const progressDotStore = useStore(() => ({
      get isCurrent() {
         return props.index === progressDotsStore.sp.index
      },
      get isCurrentOrPrevious() {
         return props.index <= progressDotsStore.sp.index
      }
   }))

   return <Box
      key={props.index}
      sx={{
         width: progressDotStore.isCurrent ? 48 : 8,
         height: 8,
         borderRadius: 4,
         bgcolor: progressDotStore.isCurrentOrPrevious ? themeConfig.primary[800] : 'transparent',
         transition: 'all 0.3s ease-in-out',
         border: !progressDotStore.isCurrentOrPrevious ? `1px solid ${themeConfig.primary[800]}` : 'none',
         transformOrigin: 'center',
      }}
   />
})
